import styled from 'styled-components'

export const NewsPageWrapper = styled.div`
   width: 100%;
   overflow-x: hidden;
`

export const NewsMain = styled.main`
   max-width: 1200px;
   margin: 0 auto;
   padding: 112px 16px 56px;

   @media (max-width: 768px) {
      padding-top: 96px;
   }
`

export const NewsHero = styled.header`
   margin-bottom: 32px;

   h1 {
      margin: 0 0 12px;
      color: #111;
      font-size: 36px;
      line-height: 1.2;
      font-weight: 700;
   }

   p {
      max-width: 760px;
      margin: 0;
      color: #4f4f4f;
      font-size: 16px;
      line-height: 1.7;
   }

   @media (max-width: 768px) {
      h1 {
         font-size: 28px;
      }
   }
`

export const NewsGrid = styled.div`
   display: grid;
   grid-template-columns: repeat(3, minmax(0, 1fr));
   gap: 24px;

   @media (max-width: 992px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
   }

   @media (max-width: 640px) {
      grid-template-columns: 1fr;
   }
`

export const NewsCard = styled.article`
   display: flex;
   flex-direction: column;
   overflow: hidden;
   min-height: 100%;
   border: 1px solid #efefef;
   background: #fff;
   box-shadow: 0 12px 28px rgba(0, 0, 0, 0.06);

   img {
      width: 100%;
      aspect-ratio: 4 / 3;
      object-fit: cover;
      display: block;
   }
`

export const NewsCardBody = styled.div`
   display: flex;
   flex: 1;
   flex-direction: column;
   padding: 18px;

   span {
      color: #9c7a11;
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
   }

   h2 {
      margin: 10px 0 10px;
      color: #111;
      font-size: 20px;
      line-height: 1.35;
      font-weight: 700;
   }

   p {
      margin: 0 0 18px;
      color: #4f4f4f;
      font-size: 14px;
      line-height: 1.65;
   }

   a {
      margin-top: auto;
      color: #111;
      font-weight: 700;
      text-decoration: underline;
      text-underline-offset: 4px;
   }
`

export const ArticleLayout = styled.article`
   max-width: 880px;
   margin: 0 auto;
   color: #222;

   h1 {
      margin: 0 0 16px;
      color: #111;
      font-size: 40px;
      line-height: 1.18;
      font-weight: 750;
   }

   h2 {
      margin: 36px 0 12px;
      color: #111;
      font-size: 24px;
      line-height: 1.35;
   }

   p {
      margin: 0 0 16px;
      font-size: 17px;
      line-height: 1.8;
   }

   img {
      width: 100%;
      margin: 24px 0;
      aspect-ratio: 16 / 9;
      object-fit: cover;
      display: block;
   }

   @media (max-width: 768px) {
      h1 {
         font-size: 30px;
      }

      p {
         font-size: 16px;
      }
   }
`

export const ArticleMeta = styled.div`
   display: flex;
   flex-wrap: wrap;
   gap: 10px;
   margin-bottom: 20px;
   color: #686868;
   font-size: 14px;
`

export const KeywordList = styled.div`
   display: flex;
   flex-wrap: wrap;
   gap: 8px;
   margin: 24px 0;

   span {
      border: 1px solid #e7d58b;
      background: #fff9de;
      color: #675000;
      padding: 6px 10px;
      font-size: 13px;
   }
`

export const TakeawayBox = styled.div`
   margin-top: 32px;
   padding: 20px;
   border-left: 4px solid #edbb1d;
   background: #fff9df;
   font-size: 17px;
   line-height: 1.7;
`
